import MyFooterBtn from './footerBtn.vue';

MyFooterBtn.install = function(Vue){
  Vue.component('MyFooterBtn', MyFooterBtn);
};

export default MyFooterBtn;